import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  alert,
  tokens,
  t,
} from "../components/CustomComponent.js";
import { isLineLinkedBrowser } from "../utils/lineLogin.js";
import Turnstile from "react-turnstile";
import { CAPTCHA_SITE_KEY, isCaptchaEnabled } from "../utils/captcha.js";
import Logo from "../components/Logo.js";
import FLAG_TH from "../assets/images/thailand.png";
import FLAG_EN from "../assets/images/usd.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/login.css";

// หน้าแรกหลังเข้าสู่ระบบ — คิดจากสิทธิ์ของบทบาท (global.getAdminHomeLink)
// บทบาทที่ไม่มีสิทธิ์ดูแดชบอร์ดจะได้เมนูแรกที่ตัวเองเข้าได้แทน

export default class Login extends Component {
  constructor(props) {
    super(props);
    const remembered = localStorage.getItem("mn-remember-email") || "";
    this.state = {
      email: remembered,
      password: "",
      password_view: "password",
      remember: !!remembered,
      token: "",
      captchaKey: Date.now(),
      lang: localStorage.getItem("lang") || "TH",
      _tokens: tokens
    };
    this.turnstileRef = createRef();
  }

  async componentDidMount() {
    // มี token ค้างอยู่ : ตรวจกับ backend ก่อนว่ายังใช้ได้ไหม แล้วค่อยเข้าระบบ
    if (tokens) {
      const result = await GET("admin/users/profile");

      if (result?.status === true) {
        localStorage.setItem("mn-profile", JSON.stringify(result.data));
        window.location.href = global.getAdminHomeLink(result.data);
        return;
      }

      localStorage.clear();
      this.setState({ _tokens: null });
    }

    loading(false);
  }

  changeLanguage = (newLang) => {
    localStorage.setItem("lang", newLang);
    window.location.reload();
  };

  ForgotPassword = () => {
    // TODO: ผูกกับหน้าลืมรหัสผ่านเมื่อมี route /forgot-password
    alert("", "warning", t("warning"), t("feature_not_available"));
  };

  // backend เป็นคนสร้างลิงก์ให้ เพราะ channel secret และ state ที่เซ็นไว้ต้องอยู่ฝั่งเซิร์ฟเวอร์
  // LINE จะ redirect กลับมาที่ /auth/line/callback (หน้า line_callback.js) พร้อม code
  //
  // linked=1 : เบราว์เซอร์นี้เคยเข้าด้วย LINE ที่ผูกบัญชีไว้แล้ว จึงขอข้ามหน้ายินยอมได้เลย
  // ถ้าไม่เคย ให้ขอยินยอมตั้งแต่รอบแรก จะได้ไม่ต้องเด้งไป LINE ซ้ำอีกรอบ
  LoginWithLine = async () => {
    loading(true);
    const result = await GET("auth/line/authorize-url", isLineLinkedBrowser() ? { linked: 1 } : null);

    if (result?.status !== true || !result.data?.authorize_url) {
      loading(false);
      return;
    }

    window.location.href = result.data.authorize_url;
  };

  Login = async () => {
    const { email, password, remember, token } = this.state;

    if (!email) return alert("", "warning", t("warning"), t("verify_email"));
    if (!password) return alert("", "warning", t("warning"), t("verify_password"));
    // วิดเจ็ตยังตรวจไม่เสร็จ — บอกให้รอ ดีกว่าปล่อยไปให้ backend ตีกลับว่าไม่ผ่าน
    if (isCaptchaEnabled() && !token) return alert("", "warning", t("warning"), t("verify_captcha"));

    loading(true);
    // backend ถอด base64 ก่อนเทียบรหัสผ่าน จึงต้องส่งแบบเข้ารหัสไว้
    const result = await POST("auth/login", {
      email: email.trim(),
      password: btoa(password),
      ...(token ? { captcha_token: token } : {}),
    });

    // POST แจ้ง error ให้แล้วเมื่อ status ไม่เป็น true จึงไม่ต้อง alert ซ้ำ
    if (result?.status !== true) {
      loading(false);
      /* ผลจาก Turnstile ใช้ได้ครั้งเดียว — พอถูกส่งไปตรวจแล้วถือว่าหมดอายุทันที
         ต้องสั่งให้วิดเจ็ตออกตัวใหม่ ไม่งั้นผู้ใช้ที่พิมพ์รหัสผ่านผิดจะติดอยู่กับ
         ผลเดิมที่ใช้ไม่ได้แล้ว แล้วลองใหม่กี่ครั้งก็ไม่ผ่านสักครั้ง
         (การเปลี่ยน key บังคับให้ React สร้างวิดเจ็ตใหม่ทั้งตัว) */
      if (isCaptchaEnabled()) this.setState({ token: "", captchaKey: Date.now() });
      return;
    }

    if (remember) {
      localStorage.setItem("mn-remember-email", email);
    } else {
      localStorage.removeItem("mn-remember-email");
    }

    localStorage.setItem("mn-acc-tk", btoa("Bearer " + result.data.token));

    // login คืนมาแค่ token — สิทธิ์ของ role ต้องดึงจากโปรไฟล์
    // เพราะ PermissionRoute และเมนูฝั่งซ้ายอ่านจาก mn-profile
    const profile = await GET("admin/users/profile");
    if (profile?.status !== true) {
      localStorage.clear();
      loading(false);
      return;
    }

    localStorage.setItem("mn-profile", JSON.stringify(profile.data));
    window.location.href = global.getAdminHomeLink(profile.data);
  };

  render() {
    const { captchaKey, email, password, password_view, remember, lang, _tokens } = this.state;

    return !_tokens ? (
        <div className="mn-login">
            {/* ============ ฝั่งซ้าย : ฟอร์มเข้าสู่ระบบ ============ */}
            <div className="mn-login__form-side">
                <div className="mn-login__topbar">
                    {/* โลโก้ */}
                    <Logo size={42} />

                    {/* เลือกภาษา */}
                    <div className="mn-lang">
                        <img className="mn-lang__flag" src={lang === "EN" ? FLAG_EN : FLAG_TH} alt="" />
                        <select className="mn-lang__select" value={lang} onChange={(e) => this.changeLanguage(e.target.value)}>
                            <option value="TH">{t("lang_thai")}</option>
                            <option value="EN">{t("lang_english")}</option>
                        </select>
                        <span className="mn-lang__caret icon">{""}</span>
                    </div>
                </div>

                <div className="mn-login__body">
                    <h1 className="mn-login__title">{t("login_title")}</h1>
                    <p className="mn-login__subtitle">{t("login_subtitle")}</p>

                    {/* อีเมล / เบอร์โทรศัพท์ */}
                    <div className="mn-field">
                        <span className="mn-field__icon icon">{""}</span>
                        <input
                            type="text"
                            className="mn-field__input"
                            placeholder={t("placeholder_email_or_phone")}
                            value={email}
                            onChange={(e) => this.setState({ email: e.target.value })}
                            onKeyUp={(e) => e.key === "Enter" && this.Login()}
                        />
                    </div>

                    {/* รหัสผ่าน */}
                    <div className="mn-field">
                        <span className="mn-field__icon icon">{""}</span>
                        <input
                            type={password_view}
                            className="mn-field__input"
                            placeholder={t("password")}
                            value={password}
                            onChange={(e) => this.setState({ password: e.target.value })}
                            onKeyUp={(e) => e.key === "Enter" && this.Login()}
                        />
                        <button
                            type="button"
                            className="mn-field__toggle"
                            aria-label={t("password")}
                            onClick={() =>
                                this.setState({
                                    password_view: password_view === "password" ? "text" : "password",
                                })
                            }
                        >
                            <span className="icon">{password_view === "password" ? "" : ""}</span>
                        </button>
                    </div>

                    {/* จดจำไว้ในระบบ + ลืมรหัสผ่าน */}
                    <div className="mn-formrow">
                        <label className="mn-check">
                            <input type="checkbox" checked={remember} onChange={(e) => this.setState({ remember: e.target.checked })} />
                            <span className="mn-check__box icon">{""}</span>
                            {t("remember_me")}
                        </label>

                        <button type="button" className="mn-link" onClick={this.ForgotPassword}>
                            {t("forgot_password")}
                        </button>
                    </div>

                    {/* CAPTCHA — แสดงเมื่อตั้ง REACT_APP_CLOUDFLARE_SITE_KEY ไว้เท่านั้น
                        (ดู utils/captcha.js) เครื่องที่ยังไม่ได้ตั้งค่าจะไม่เห็นอะไรตรงนี้
                        และ backend ก็ข้ามการตรวจให้เองเมื่อไม่มี TURNSTILE_SECRET_KEY */}
                    {isCaptchaEnabled() && (
                        <Turnstile
                            key={captchaKey}
                            size="flexible"
                            sitekey={CAPTCHA_SITE_KEY}
                            onVerify={(token) => this.setState({ token })}
                            /* หมดอายุเองระหว่างที่ผู้ใช้ยังกรอกฟอร์มค้างไว้ — ต้องล้างทิ้ง
                               ไม่งั้นจะส่งผลที่ใช้ไม่ได้ขึ้นไปแล้วโดนตีกลับโดยไม่รู้สาเหตุ */
                            onExpire={() => this.setState({ token: "" })}
                            onError={() => this.setState({ token: "" })}
                        />
                    )}

                    {/* ปุ่มเข้าสู่ระบบ */}
                    <button className="mn-btn mn-btn--primary" onClick={this.Login}>
                        {t("sign_in")}
                    </button>

                    <div className="mn-divider">{t("or")}</div>

                    {/* เข้าสู่ระบบด้วย LINE */}
                    <button className="mn-btn mn-btn--line" onClick={this.LoginWithLine}>
                        <span className="mn-line-badge">LINE</span>
                        {t("sign_in_with_line")}
                    </button>

                    {/* แจ้งการเก็บข้อมูลก่อนกดยินยอมกับ LINE — LINE Developers Console
                ใช้ภาพหน้าจอส่วนนี้ประกอบการอนุมัติสิทธิ์ขออีเมล ห้ามเอาออก */}
                    <p className="mn-login__policy">
                        {t("login_policy_note")}{" "}
                        <a href="/policy-privacy" target="_blank" rel="noopener noreferrer">
                            {t("policy_privacy")}
                        </a>
                    </p>
                </div>

                <div className="mn-login__footer">
                    <div>© {new Date().getFullYear()} SafeSpace Life Living Co., Ltd.</div>
                    <div>
                        {t("all_rights_reserved")} · v{global.version}
                    </div>
                </div>
            </div>

            {/* ============ ฝั่งขวา : ภาพโปรโมท ============ */}
            <div className="mn-hero">
                <span className="mn-hero__scrim" />
                <span className="mn-hero__wedge" />

                <div className="mn-hero__content">
                    <h2 className="mn-hero__title">
                        {t("hero_title")}
                        <em>{t("hero_highlight")}</em>
                        <em>{t("hero_title_end")}</em>
                    </h2>

                    <ul className="mn-hero__list">
                        <li>
                            <span className="mn-hero__bullet icon">{""}</span>
                            {t("feature_manage_property")}
                        </li>
                        <li>
                            <span className="mn-hero__bullet icon">{""}</span>
                            {t("feature_customer_owner")}
                        </li>
                        <li>
                            <span className="mn-hero__bullet icon">{""}</span>
                            {t("feature_realtime_report")}
                        </li>
                    </ul>
                </div>

                <div className="mn-hero__card">
                    <span className="mn-hero__card-icon icon">{""}</span>
                    <div>
                        <p className="mn-hero__card-title">{t("secure_title")}</p>
                        <p className="mn-hero__card-desc">{t("secure_desc_1")}</p>
                        <p className="mn-hero__card-desc">{t("secure_desc_2")}</p>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
  }
}
